import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
    ICreateTnaMilestoneRequest,
    ITnaMilestone,
    IUpdateTnaMilestoneRequest,
} from '../interfaces/garments/tnaMilestone.interface';

const headers = () => AuthService.getAuthHeader();

export const TnaMilestoneService = {
    list: async (institutionId: string, orderId: string): Promise<ITnaMilestone[]> => {
        const res = await axios.get(ENDPOINTS.TNA_MILESTONE.LIST(institutionId, orderId), { headers: headers() });
        return res.data;
    },

    generate: async (institutionId: string, orderId: string): Promise<ITnaMilestone[]> => {
        const res = await axios.post(ENDPOINTS.TNA_MILESTONE.GENERATE(institutionId, orderId), null, { headers: headers() });
        return res.data;
    },

    create: async (institutionId: string, orderId: string, request: ICreateTnaMilestoneRequest): Promise<ITnaMilestone> => {
        const res = await axios.post(ENDPOINTS.TNA_MILESTONE.CREATE(institutionId, orderId), request, { headers: headers() });
        return res.data;
    },

    update: async (
        institutionId: string,
        orderId: string,
        milestoneId: string,
        request: IUpdateTnaMilestoneRequest
    ): Promise<ITnaMilestone> => {
        const res = await axios.put(
            ENDPOINTS.TNA_MILESTONE.UPDATE(institutionId, orderId, milestoneId),
            request,
            { headers: headers() }
        );
        return res.data;
    },

    remove: async (institutionId: string, orderId: string, milestoneId: string): Promise<void> => {
        await axios.delete(ENDPOINTS.TNA_MILESTONE.DELETE(institutionId, orderId, milestoneId), { headers: headers() });
    },
};
